import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import UFOSegment from "@atlaskit/react-ufo/segment";
import { token } from "@atlaskit/tokens";

import { Adg4Button } from "@/components/adg4/button/src";
import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";

export const HeroSection = () => {
    const intl = useIntl();

    const heroSectionHeaderText = (
        <FormattedMessage
            id="EnterpriseLandingPage.Hero.Title"
            defaultMessage="Transform <span>teamwork at scale</span> with Atlassian"
            values={DEFAULT_VALUES}
        />
    );

    const heroSectionButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.Hero.ContactSales",
        defaultMessage: "Contact sales"
    });
    return (
        <UFOSegment name="enterprise-page-hero">
            <div css={heroStyle}>
                <Row alignItems="center" layout="12">
                    <div css={heroSectionBoxStyle}>
                        <h1 className="superhero-contrast">
                            {heroSectionHeaderText}
                        </h1>
                        <Adg4Button
                            variant="primary"
                            href={useLocalizedHref(
                                "/enterprise/contact?formType=product-features"
                            )}
                            dataEventProps={{
                                "data-product-key": "enterprise",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-event": "clicked",
                                "data-label": heroSectionButtonText,
                                "data-label-english": "Contact sales"
                            }}
                        >
                            {heroSectionButtonText}
                        </Adg4Button>
                    </div>
                </Row>
            </div>
        </UFOSegment>
    );
};

const heroStyle = css({
    [media.below.xs]: {
        // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& > div": {
            padding: "0 30px"
        }
    },
    [media.only.xs]: {
        // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& > div": {
            padding: "0 60px"
        }
    },
    position: "relative"
});

const heroSectionBoxStyle = css({
    [media.below.xs]: {
        backgroundSize: "14%, 48%, 32%, 20%",
        backgroundPosition: "0 -2%, -24% 82%, 81% 100%, 100% 100%",
        margin: "20px 0 60px",
        // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h1: {
            width: "98%"
        }
    },

    [media.only.xs]: {
        backgroundSize: "14%, 38%, 23%, 20%",
        backgroundPosition: "0 -2%, -14% 98%, 87% 100%, 100% 100%",
        margin: "60px 0",
        // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h1: {
            width: "80%"
        }
    },

    [media.only.sm]: {
        backgroundSize: "10%, 32%, 20%, 18%",
        backgroundPosition: "0 -2%, -11% 98%, 87% 100%, 100% 100%",
        // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h1: {
            width: "82%"
        }
    },

    textAlign: "center",
    position: "relative",
    border: "1px solid #DFE1E6",
    borderRadius: "20px",
    margin: "60px 0",
    overflow: "hidden",
    minHeight: "350px",
    backgroundImage:
        'url("https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-quarter-circle.webp-2345858369.webp"), url("https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-graph.webp-3089236614.webp"), url("https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-grid.webp-3189788274.webp"), url("https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-bars.webp-2356904232.webp")',
    backgroundPosition: "0 0, 0 100%, 87% 100%, 100% 100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "12%, 24%, 16%, 18%",
    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    h1: {
        maxWidth: "768px",
        width: "62%",
        margin: `${token("space.800")} auto ${token("space.300")}`,
        // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        span: {
            fontWeight: 700
        }
    },
    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    a: {
        margin: "0 auto 30px",
        fontWeight: 400
    }
});
